import React from 'react';
import { AwardIcon, LockIcon, ShieldCheckIcon, ZapIcon } from 'lucide-react';
import { Button } from './ui/Button';
import { SectionHeading } from './ui/SectionHeading';
import { checkoutUrl, price, priceBefore, productShortName, totalBonuses, totalVolumes } from '../data/offer';
export function PricingSection() {
  return <section id="pricing" className="scroll-mt-4 bg-navy py-16 sm:py-24" aria-labelledby="pricing-title" data-id="element-140" data-mp="1j9qpghfdfsh6">
      <div className="mx-auto max-w-3xl px-4" data-id="element-141" data-mp="1na0thojls8te">
        <SectionHeading id="pricing-title" data-id="element-142" data-mp="1s9n9g5qtg35w">Choose Your Option</SectionHeading>

        <article className="mt-10 overflow-hidden rounded-3xl border-2 border-electric bg-industrial shadow-glow-strong" data-id="element-143" data-mp="1sbq3d0v3agfw">
          <div className="border-b border-electric/30 bg-navy/50 px-6 py-4 sm:px-10" data-id="element-144" data-mp="227jh2nkjofz9">
            <span className="inline-flex items-center gap-2 rounded-full bg-gold px-3 py-1.5 font-display text-sm font-extrabold uppercase tracking-[.14em] text-navy" data-id="element-145" data-mp="2up3k6xz1vxf">
              <AwardIcon className="h-4 w-4" aria-hidden="true" data-id="element-146" data-mp="7u21pnuampfb" /> Main Offer
            </span>
          </div>
          <div className="p-6 sm:p-10" data-id="element-147" data-mp="1mirdkkgwed17">
            <div className="flex flex-col gap-6 sm:flex-row sm:items-end sm:justify-between" data-id="element-148" data-mp="1hpg2u88ytc40">
              <div data-id="element-149" data-mp="1cqbwdpdfdshd">
                <h3 className="font-display text-3xl font-bold leading-tight tracking-tight text-silver sm:text-4xl" data-id="element-150" data-mp="1crws3ibh7hgt">{productShortName}</h3>
                <p className="mt-2 text-sm text-steel" data-id="element-151" data-mp="17pp9wb01z561">
                  All {totalVolumes} volumes + {totalBonuses} exclusive bonuses
                </p>
              </div>
              <div className="shrink-0 sm:text-right" data-id="element-152" data-mp="20hqzhkd10dto">
                <span className="text-sm text-steel" data-id="element-153" data-mp="1vh328gy7f0r0">
                  Regular price: <span className="line-through decoration-electric decoration-2" data-id="element-154" data-mp="1vjfrzga7efem">{priceBefore}</span>
                </span>
                <p className="mt-2 text-xs font-bold uppercase tracking-[.14em] text-silver" data-id="element-155" data-mp="k1xxz8ifcu5a">Today:</p>
                <p className="mt-1 whitespace-nowrap font-display text-6xl font-extrabold leading-none tracking-tight text-gold sm:text-7xl" data-id="element-156" data-mp="g0ugyion4s2h">{price}</p>
              </div>
            </div>

            <Button href={checkoutUrl} target="_blank" rel="noopener noreferrer" arrow className="mt-9 w-full" data-id="element-157" data-mp="mgultjks5der">
              Get my professional edition now
            </Button>

            <div className="mt-6 flex flex-wrap justify-center gap-x-5 gap-y-2 text-sm font-semibold text-steel" data-id="element-158" data-mp="7logkytidimh">
              <span className="inline-flex items-center gap-1.5" data-id="element-159" data-mp="3uwo4o52l30yz">
                <LockIcon className="h-4 w-4 text-electric" aria-hidden="true" data-id="element-160" data-mp="3uvd1a6d1vv8e" /> Secure payment
              </span>
              <span className="inline-flex items-center gap-1.5" data-id="element-161" data-mp="3k35nj0jbeex">
                <ZapIcon className="h-4 w-4 text-electric" aria-hidden="true" data-id="element-162" data-mp="3kzt5djyhkwjn" /> Instant access
              </span>
              <span className="inline-flex items-center gap-1.5" data-id="element-163" data-mp="3pxuqsbjdx7ya">
                <ShieldCheckIcon className="h-4 w-4 text-electric" aria-hidden="true" data-id="element-164" data-mp="3byv1d1o1sp12" /> 7-day guarantee
              </span>
            </div>
          </div>
        </article>
      </div>
    </section>;
}